// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_user.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { Empty } from "../../../../google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { AppRef } from "./app";
import { App } from "./app";
import { Facets } from "../../search/v1/facet";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Struct } from "../../../../google/protobuf/struct";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.app.v1.SearchOrphanedAccountsRequest
 */
export interface SearchOrphanedAccountsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 4
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchOrphanedAccountsResponse
 */
export interface SearchOrphanedAccountsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 1
     */
    list: AppUserView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.UserAndCount
 */
export interface UserAndCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1
     */
    appUser?: AppUser;
    /**
     * @generated from protobuf field: int64 count = 2
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskUsersAndGrantsRequest
 */
export interface HighRiskUsersAndGrantsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 3
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskUsersAndGrantsResponse
 */
export interface HighRiskUsersAndGrantsResponse {
    /**
     * @generated from protobuf field: repeated int64 counts = 1
     */
    counts: number[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 2
     */
    list: AppUserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 4
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountHighRiskUsersAndGrantsRequest
 */
export interface CountHighRiskUsersAndGrantsRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.CountHighRiskUsersAndGrantsResponse
 */
export interface CountHighRiskUsersAndGrantsResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserResponsiblePartyExpandMask
 */
export interface AppUserResponsiblePartyExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceGetRequest
 */
export interface AppUserResponsiblePartyServiceGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask = 3
     */
    expandMask?: AppUserResponsiblePartyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceSetRequest
 */
export interface AppUserResponsiblePartyServiceSetRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string user_id = 3
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask = 4
     */
    expandMask?: AppUserResponsiblePartyExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceResetRequest
 */
export interface AppUserResponsiblePartyServiceResetRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask = 3
     */
    expandMask?: AppUserResponsiblePartyExpandMask;
}
/**
 * The AppUserExpandMask message contains a list of paths to expand in the response.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserExpandMask
 */
export interface AppUserExpandMask {
    /**
     * The paths to expand in the response. May be any combination of "*", "identity_user_id", "app_id", and "last_usage".
     *
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * The AppUserView contains an app user as well as paths for apps, identity users, and last usage in expanded arrays.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserView
 */
export interface AppUserView {
    /**
     * The AppUser included in this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1
     */
    appUser?: AppUser;
    /**
     * JSONPATH expression indicating where the identity user is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string identity_user_path = 2
     */
    identityUserPath: string;
    /**
     * JSONPATH expression indicating where the app is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string app_path = 3
     */
    appPath: string;
    /**
     * JSONPATH expression indicating where the last usage information is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string last_usage_path = 4
     */
    lastUsagePath: string;
}
/**
 * The AppUserView contains an app user as well as paths for apps, identity users, and last usage in expanded arrays.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserWithAlertCountView
 */
export interface AppUserWithAlertCountView {
    /**
     * The AppUser included in this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1
     */
    appUser?: AppUser;
    /**
     * JSONPATH expression indicating where the identity user is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string identity_user_path = 2
     */
    identityUserPath: string;
    /**
     * JSONPATH expression indicating where the app is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string app_path = 3
     */
    appPath: string;
    /**
     * JSONPATH expression indicating where the last usage information is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string last_usage_path = 4
     */
    lastUsagePath: string;
    /**
     * count of active alerts
     *
     * @generated from protobuf field: int32 alert_count = 5
     */
    alertCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceGetResponse
 */
export interface AppUserServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView app_user_view = 1
     */
    appUserView?: AppUserView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceUpdateResponse
 */
export interface AppUserServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserView app_user_view = 1
     */
    appUserView?: AppUserView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * The satus of the applicaiton user.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserStatus
 */
export interface AppUserStatus {
    /**
     * The application user status field.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserStatus.Status status = 1
     */
    status: AppUserStatus_Status;
    /**
     * The details of applicaiton user status.
     *
     * @generated from protobuf field: string details = 2
     */
    details: string;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppUserStatus.Status
 */
export enum AppUserStatus_Status {
    /**
     * Indicates that the application user account status is unknown. This should be considered invalid in a response message.
     *
     * @generated from protobuf enum value: STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Indicates that the application user account is active.
     *
     * @generated from protobuf enum value: STATUS_ENABLED = 1;
     */
    ENABLED = 1,
    /**
     * Indicates that the application user account is disabled.
     *
     * @generated from protobuf enum value: STATUS_DISABLED = 2;
     */
    DISABLED = 2,
    /**
     * Indicates that the application user account is deleted.
     *
     * @generated from protobuf enum value: STATUS_DELETED = 3;
     */
    DELETED = 3
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserRef
 */
export interface AppUserRef {
    /**
     * The ID of the application.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialRef
 */
export interface AppUserCredentialRef {
    /**
     * The ID of the application.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app user.
     *
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * The ID of the credential.
     *
     * @generated from protobuf field: string id = 3
     */
    id: string;
}
/**
 * Application User that represents an account in the application.
 *
 * @generated from protobuf message c1.api.app.v1.AppUser
 */
export interface AppUser {
    /**
     * The ID of the application.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * A unique idenditfier of the application user.
     *
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the Application user was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Application user was updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Application user was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the application user.
     *
     * @generated from protobuf field: string display_name = 6
     */
    displayName: string;
    /**
     * The email field of the application user.
     *
     * @generated from protobuf field: string email = 7
     */
    email: string;
    /**
     * The emails field of the application user.
     *
     * @generated from protobuf field: repeated string emails = 12
     */
    emails: string[];
    /**
     * The username field of the application user.
     *
     * @generated from protobuf field: string username = 13
     */
    username: string;
    /**
     * The usernames field of the application user.
     *
     * @generated from protobuf field: repeated string usernames = 14
     */
    usernames: string[];
    /**
     * The employee IDs field of the application user.
     *
     * @generated from protobuf field: repeated string employee_ids = 16
     */
    employeeIds: string[];
    /**
     * The profile attributes of the user in the application.
     *
     * @generated from protobuf field: google.protobuf.Struct profile = 8
     */
    profile?: Struct;
    /**
     * The appplication user type. Type can be user, system or service.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserType app_user_type = 9
     */
    appUserType: AppUserType;
    /**
     * The conductor one user ID of the account owner.
     *
     * @generated from protobuf field: string identity_user_id = 10
     */
    identityUserId: string;
    /**
     * The status of the user in the application.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserStatus status = 11
     */
    status?: AppUserStatus;
    /**
     * @generated from protobuf field: bool is_external = 15
     */
    isExternal: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceCreateRequest
 */
export interface AppUserServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string email = 3
     */
    email: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 4
     */
    expandMask?: AppUserExpandMask;
}
/**
 * The AppUserServiceUpdateRequest message contains the app user and the fields to be updated.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserServiceUpdateRequest
 */
export interface AppUserServiceUpdateRequest {
    /**
     * The app user with the fields to be updated.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1
     */
    appUser?: AppUser;
    /**
     * A comma sepparated list of fields to update from the app user. For example: "appUserType,identityUserId"
     * NOTE: If you specify identityUserId in the update mask, and the identityUserId field is empty in the request body, the identityUserId will be reset to the default.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
    /**
     * The expand mask defines the list of paths to be expanded in the return value.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 3
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceGetRequest
 */
export interface AppUserServiceGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 3
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceDeleteRequest
 */
export interface AppUserServiceDeleteRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceListRequest
 */
export interface AppUserServiceListRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 4
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceListResponse
 */
export interface AppUserServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 1
     */
    list: AppUserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUsersForUserServiceListRequest
 */
export interface AppUsersForUserServiceListRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 2
     */
    userId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 5
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUsersForUserServiceListResponse
 */
export interface AppUsersForUserServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 1
     */
    list: AppUserView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * Search App users based on filters specified in the request body
 *
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchRequest
 */
export interface AppUserServiceSearchRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * A list of app user IDs to remove from the results.
     *
     * @generated from protobuf field: repeated string exclude_app_user_ids = 4
     */
    excludeAppUserIds: string[];
    /**
     * A list of app user IDs to restrict the search to.
     *
     * @generated from protobuf field: repeated string app_user_ids = 5
     */
    appUserIds: string[];
    /**
     * The app ID to restrict the search to.
     *
     * @generated from protobuf field: string app_id = 6
     */
    appId: string;
    /**
     * A list of app user types to restrict the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserType app_user_types = 8
     */
    appUserTypes: AppUserType[];
    /**
     * A list of app user statuses to restrict the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses = 9
     */
    appUserStatuses: AppUserStatus_Status[];
    /**
     * A list of app user status details to restrict the search to.
     *
     * @generated from protobuf field: repeated string app_user_status_details = 10
     */
    appUserStatusDetails: string[];
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 7
     */
    expandMask?: AppUserExpandMask;
    /**
     * A list of user IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string user_ids = 11
     */
    userIds: string[];
    /**
     * A list of app users to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef refs = 12
     */
    refs: AppUserRef[];
    /**
     * A list of account domains to restrict the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserDomain app_user_domains = 14
     */
    appUserDomains: AppUserDomain[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchResponse
 */
export interface AppUserServiceSearchResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserView list = 1
     */
    list: AppUserView[];
    /**
     * List of related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retrieved.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * Search App users along with inventory alert count based on filters specified in the request body
 *
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchWithAlertsRequest
 */
export interface AppUserServiceSearchWithAlertsRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * A list of app user IDs to remove from the results.
     *
     * @generated from protobuf field: repeated string exclude_app_user_ids = 4
     */
    excludeAppUserIds: string[];
    /**
     * A list of app user IDs to restrict the search to.
     *
     * @generated from protobuf field: repeated string app_user_ids = 5
     */
    appUserIds: string[];
    /**
     * The app ID to restrict the search to.
     *
     * @generated from protobuf field: string app_id = 6
     */
    appId: string;
    /**
     * A list of app user types to restrict the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserType app_user_types = 8
     */
    appUserTypes: AppUserType[];
    /**
     * A list of app user statuses to restrict the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses = 9
     */
    appUserStatuses: AppUserStatus_Status[];
    /**
     * A list of app user status details to restrict the search to.
     *
     * @generated from protobuf field: repeated string app_user_status_details = 10
     */
    appUserStatusDetails: string[];
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 7
     */
    expandMask?: AppUserExpandMask;
    /**
     * A list of user IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string user_ids = 11
     */
    userIds: string[];
    /**
     * A list of app users to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef refs = 12
     */
    refs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserDomain app_user_domains = 13
     */
    appUserDomains: AppUserDomain[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchWithAlertsResponse
 */
export interface AppUserServiceSearchWithAlertsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserWithAlertCountView list = 1
     */
    list: AppUserWithAlertCountView[];
    /**
     * List of related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retrieved.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchCountsByTypeRequest
 */
export interface AppUserServiceSearchCountsByTypeRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchCountRequest
 */
export interface AppUserServiceSearchCountRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_app_user_ids = 2
     */
    excludeAppUserIds: string[];
    /**
     * @generated from protobuf field: repeated string app_user_ids = 3
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: string app_id = 4
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserType app_user_types = 5
     */
    appUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses = 6
     */
    appUserStatuses: AppUserStatus_Status[];
    /**
     * @generated from protobuf field: repeated string app_user_status_details = 7
     */
    appUserStatusDetails: string[];
    /**
     * @generated from protobuf field: repeated string user_ids = 8
     */
    userIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef refs = 9
     */
    refs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserDomain app_user_domains = 11
     */
    appUserDomains: AppUserDomain[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchCountResponse
 */
export interface AppUserServiceSearchCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceSearchCountsByTypeResponse
 */
export interface AppUserServiceSearchCountsByTypeResponse {
    /**
     * @generated from protobuf field: int64 user = 1
     */
    user: number;
    /**
     * @generated from protobuf field: int64 service_account = 2
     */
    serviceAccount: number;
    /**
     * @generated from protobuf field: int64 system_account = 3
     */
    systemAccount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetUserSearchTermsRequest
 */
export interface GetUserSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserServiceSearchRequest search = 1
     */
    search?: AppUserServiceSearchRequest;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserSearchTerm term = 2
     */
    term: AppUserSearchTerm;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetUserSearchTermsResponse
 */
export interface GetUserSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppWithUserCountRollup
 */
export interface AppWithUserCountRollup {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: int64 user_count = 2
     */
    userCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppWithUserCountRollupRequest
 */
export interface AppWithUserCountRollupRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppWithUserCountRollupResponse
 */
export interface AppWithUserCountRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppWithUserCountRollup list = 1
     */
    list: AppWithUserCountRollup[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountAppUsersWithoutResponsiblePartyRequest
 */
export interface CountAppUsersWithoutResponsiblePartyRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.CountAppUsersWithoutResponsiblePartyResponse
 */
export interface CountAppUsersWithoutResponsiblePartyResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUsersWithoutResponsiblePartyRequest
 */
export interface AppUsersWithoutResponsiblePartyRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 4
     */
    expandMask?: AppUserExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.TotalCountOrphanedAccountsRequest
 */
export interface TotalCountOrphanedAccountsRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.TotalCountOrphanedAccountsResponse
 */
export interface TotalCountOrphanedAccountsResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * EncryptedData is a message that contains encrypted bytes and metadata.
 *
 * @generated from protobuf message c1.api.app.v1.EncryptedData
 */
export interface EncryptedData {
    /**
     * The encryption provider used to encrypt the data.
     *
     * @generated from protobuf field: string provider = 1
     */
    provider: string;
    /**
     * The key ID used to encrypt the data.
     *
     * @generated from protobuf field: string key_id = 2
     */
    keyId: string;
    /**
     * The human-readable name of the encrypted data.
     *
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * The human-readable description of the encrypted data.
     *
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * The (optional) JSON schema of the encrypted data.
     *
     * @generated from protobuf field: string schema = 5
     */
    schema: string;
    /**
     * The encrypted bytes.
     *
     * @generated from protobuf field: bytes encrypted_bytes = 6
     */
    encryptedBytes: Uint8Array;
}
/**
 * A credentials for the Application User that represents an account in the application.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserCredential
 */
export interface AppUserCredential {
    /**
     * The ID of the application.
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * A unique identifier of the application user.
     *
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * A unique identifier of the credential.
     *
     * @generated from protobuf field: string id = 3
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the credential was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the credential was updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the credential was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6
     */
    deletedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the credential will expire.
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 7
     */
    expiresAt?: Timestamp;
    /**
     * The actual encrypted credential. Only option today is encrypted bytes, but there could be more in the future
     *
     * @generated from protobuf oneof: credential
     */
    credential: {
        oneofKind: "encryptedData";
        /**
         * The encrypted data of the credential.
         *
         * @generated from protobuf field: c1.api.app.v1.EncryptedData encrypted_data = 100
         */
        encryptedData: EncryptedData;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialView
 */
export interface AppUserCredentialView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserCredential app_user_credential = 1
     */
    appUserCredential?: AppUserCredential;
    /**
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * @generated from protobuf field: string app_user_path = 3
     */
    appUserPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialViewWithVaultID
 */
export interface AppUserCredentialViewWithVaultID {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserCredentialView item = 1
     */
    item?: AppUserCredentialView;
    /**
     * @generated from protobuf field: string vault_id = 2
     */
    vaultId: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialExpandMask
 */
export interface AppUserCredentialExpandMask {
    /**
     * The paths to expand in the response. May be any combination of "*", "app_id", and "app_user_id".
     *
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceListCredentialsRequest
 */
export interface AppUserServiceListCredentialsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserServiceListCredentialsResponse
 */
export interface AppUserServiceListCredentialsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserCredential list = 1
     */
    list: AppUserCredential[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserSearchFilter
 */
export interface AppUserSearchFilter {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef refs = 1
     */
    refs: AppUserRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest
 */
export interface AppUserCredentialServiceSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.SearchAppUserCredentialsByVaultIDRequest search = 1
     */
    search?: SearchAppUserCredentialsByVaultIDRequest;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest.TermType term = 2
     */
    term: AppUserCredentialServiceSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest.TermType
 */
export enum AppUserCredentialServiceSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APPS = 1;
     */
    APPS = 1
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialServiceSearchTermsResponse
 */
export interface AppUserCredentialServiceSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppUserCredentialsWithVaultRequest
 */
export interface ListAppUserCredentialsWithVaultRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserCredentialExpandMask expand_mask = 5
     */
    expandMask?: AppUserCredentialExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppUserCredentialsWithVaultResponse
 */
export interface ListAppUserCredentialsWithVaultResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserCredentialViewWithVaultID list = 1
     */
    list: AppUserCredentialViewWithVaultID[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUserCredentialsByVaultIDRequest
 */
export interface SearchAppUserCredentialsByVaultIDRequest {
    /**
     * @generated from protobuf field: string vault_id = 1
     */
    vaultId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserCredentialExpandMask expand_mask = 4
     */
    expandMask?: AppUserCredentialExpandMask;
    /**
     * Fuzzy search
     *
     * @generated from protobuf field: string query = 5
     */
    query: string;
    /**
     * A list of app IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string app_ids = 6
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUserCredentialsByVaultIDResponse
 */
export interface SearchAppUserCredentialsByVaultIDResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserCredentialView list = 1
     */
    list: AppUserCredentialView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUserHasAppUserCredentialsRequest
 */
export interface SearchAppUserHasAppUserCredentialsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUserHasAppUserCredentialsResponse
 */
export interface SearchAppUserHasAppUserCredentialsResponse {
    /**
     * @generated from protobuf field: bool has_app_user_credentials = 1
     */
    hasAppUserCredentials: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialServiceDeleteRequest
 */
export interface AppUserCredentialServiceDeleteRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string credential_id = 3
     */
    credentialId: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.app.v1.AppUserCredentialServiceDeleteResponse
 */
export interface AppUserCredentialServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppAccountRollup
 */
export interface AppAccountRollup {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: int64 count = 2
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountAppUsersByAppsRequest
 */
export interface CountAppUsersByAppsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppRef app_refs = 1
     */
    appRefs: AppRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.CountAppUsersByAppsResponse
 */
export interface CountAppUsersByAppsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppAccountRollup list = 1
     */
    list: AppAccountRollup[];
}
/**
 * Different application user types.
 * Copied in c1.api.task.v1.Search, c1.api.accessreview.v1.accessreview
 * There's an issue with protogen when referencing enums from other packages.
 *
 * @generated from protobuf enum c1.api.app.v1.AppUserType
 */
export enum AppUserType {
    /**
     * User type is not specified. This should be considered an invalid state in a response.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Identifies the user as a person.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_USER = 1;
     */
    USER = 1,
    /**
     * Identifies the user as a service.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_SERVICE_ACCOUNT = 2;
     */
    SERVICE_ACCOUNT = 2,
    /**
     * Identifies the user as a system.
     *
     * @generated from protobuf enum value: APP_USER_TYPE_SYSTEM_ACCOUNT = 3;
     */
    SYSTEM_ACCOUNT = 3
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppUserDomain
 */
export enum AppUserDomain {
    /**
     * @generated from protobuf enum value: APP_USER_DOMAIN_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_USER_DOMAIN_EXTERNAL = 1;
     */
    EXTERNAL = 1,
    /**
     * @generated from protobuf enum value: APP_USER_DOMAIN_TRUSTED = 2;
     */
    TRUSTED = 2
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppUserSearchTerm
 */
export enum AppUserSearchTerm {
    /**
     * @generated from protobuf enum value: APP_USER_STATUS = 0;
     */
    APP_USER_STATUS = 0,
    /**
     * @generated from protobuf enum value: APP_USER_TYPE = 1;
     */
    APP_USER_TYPE = 1,
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_DETAILS = 2;
     */
    APP_USER_STATUS_DETAILS = 2,
    /**
     * @generated from protobuf enum value: IDENTITY_USER_IDS = 3;
     */
    IDENTITY_USER_IDS = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrphanedAccountsRequest$Type extends MessageType<SearchOrphanedAccountsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchOrphanedAccountsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchOrphanedAccountsRequest>): SearchOrphanedAccountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchOrphanedAccountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrphanedAccountsRequest): SearchOrphanedAccountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 4:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOrphanedAccountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchOrphanedAccountsRequest
 */
export const SearchOrphanedAccountsRequest = new SearchOrphanedAccountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchOrphanedAccountsResponse$Type extends MessageType<SearchOrphanedAccountsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchOrphanedAccountsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchOrphanedAccountsResponse>): SearchOrphanedAccountsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchOrphanedAccountsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchOrphanedAccountsResponse): SearchOrphanedAccountsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUserView list */ 1:
                    message.list.push(AppUserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchOrphanedAccountsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchOrphanedAccountsResponse
 */
export const SearchOrphanedAccountsResponse = new SearchOrphanedAccountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserAndCount$Type extends MessageType<UserAndCount> {
    constructor() {
        super("c1.api.app.v1.UserAndCount", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<UserAndCount>): UserAndCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<UserAndCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UserAndCount): UserAndCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUser app_user */ 1:
                    message.appUser = AppUser.internalBinaryRead(reader, reader.uint32(), options, message.appUser);
                    break;
                case /* int64 count */ 2:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UserAndCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUser app_user = 1; */
        if (message.appUser)
            AppUser.internalBinaryWrite(message.appUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UserAndCount
 */
export const UserAndCount = new UserAndCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskUsersAndGrantsRequest$Type extends MessageType<HighRiskUsersAndGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.HighRiskUsersAndGrantsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
    create(value?: PartialMessage<HighRiskUsersAndGrantsRequest>): HighRiskUsersAndGrantsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<HighRiskUsersAndGrantsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HighRiskUsersAndGrantsRequest): HighRiskUsersAndGrantsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 3:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HighRiskUsersAndGrantsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskUsersAndGrantsRequest
 */
export const HighRiskUsersAndGrantsRequest = new HighRiskUsersAndGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskUsersAndGrantsResponse$Type extends MessageType<HighRiskUsersAndGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.HighRiskUsersAndGrantsResponse", [
            { no: 1, name: "counts", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 4, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<HighRiskUsersAndGrantsResponse>): HighRiskUsersAndGrantsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.counts = [];
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<HighRiskUsersAndGrantsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HighRiskUsersAndGrantsResponse): HighRiskUsersAndGrantsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int64 counts */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.counts.push(reader.int64().toNumber());
                    else
                        message.counts.push(reader.int64().toNumber());
                    break;
                case /* repeated c1.api.app.v1.AppUserView list */ 2:
                    message.list.push(AppUserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 4:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HighRiskUsersAndGrantsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated int64 counts = 1; */
        if (message.counts.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.counts.length; i++)
                writer.int64(message.counts[i]);
            writer.join();
        }
        /* repeated c1.api.app.v1.AppUserView list = 2; */
        for (let i = 0; i < message.list.length; i++)
            AppUserView.internalBinaryWrite(message.list[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 4; */
        if (message.nextPageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskUsersAndGrantsResponse
 */
export const HighRiskUsersAndGrantsResponse = new HighRiskUsersAndGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountHighRiskUsersAndGrantsRequest$Type extends MessageType<CountHighRiskUsersAndGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.CountHighRiskUsersAndGrantsRequest", []);
    }
    create(value?: PartialMessage<CountHighRiskUsersAndGrantsRequest>): CountHighRiskUsersAndGrantsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CountHighRiskUsersAndGrantsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountHighRiskUsersAndGrantsRequest): CountHighRiskUsersAndGrantsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountHighRiskUsersAndGrantsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountHighRiskUsersAndGrantsRequest
 */
export const CountHighRiskUsersAndGrantsRequest = new CountHighRiskUsersAndGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountHighRiskUsersAndGrantsResponse$Type extends MessageType<CountHighRiskUsersAndGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.CountHighRiskUsersAndGrantsResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountHighRiskUsersAndGrantsResponse>): CountHighRiskUsersAndGrantsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountHighRiskUsersAndGrantsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountHighRiskUsersAndGrantsResponse): CountHighRiskUsersAndGrantsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountHighRiskUsersAndGrantsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountHighRiskUsersAndGrantsResponse
 */
export const CountHighRiskUsersAndGrantsResponse = new CountHighRiskUsersAndGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserResponsiblePartyExpandMask$Type extends MessageType<AppUserResponsiblePartyExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppUserResponsiblePartyExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserResponsiblePartyExpandMask>): AppUserResponsiblePartyExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppUserResponsiblePartyExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserResponsiblePartyExpandMask): AppUserResponsiblePartyExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserResponsiblePartyExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserResponsiblePartyExpandMask
 */
export const AppUserResponsiblePartyExpandMask = new AppUserResponsiblePartyExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserResponsiblePartyServiceGetRequest$Type extends MessageType<AppUserResponsiblePartyServiceGetRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserResponsiblePartyServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppUserResponsiblePartyExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppUserResponsiblePartyServiceGetRequest>): AppUserResponsiblePartyServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserResponsiblePartyServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserResponsiblePartyServiceGetRequest): AppUserResponsiblePartyServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask */ 3:
                    message.expandMask = AppUserResponsiblePartyExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserResponsiblePartyServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppUserResponsiblePartyExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceGetRequest
 */
export const AppUserResponsiblePartyServiceGetRequest = new AppUserResponsiblePartyServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserResponsiblePartyServiceSetRequest$Type extends MessageType<AppUserResponsiblePartyServiceSetRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserResponsiblePartyServiceSetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserResponsiblePartyExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppUserResponsiblePartyServiceSetRequest>): AppUserResponsiblePartyServiceSetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserResponsiblePartyServiceSetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserResponsiblePartyServiceSetRequest): AppUserResponsiblePartyServiceSetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* string user_id */ 3:
                    message.userId = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask */ 4:
                    message.expandMask = AppUserResponsiblePartyExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserResponsiblePartyServiceSetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* string user_id = 3; */
        if (message.userId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userId);
        /* c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppUserResponsiblePartyExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceSetRequest
 */
export const AppUserResponsiblePartyServiceSetRequest = new AppUserResponsiblePartyServiceSetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserResponsiblePartyServiceResetRequest$Type extends MessageType<AppUserResponsiblePartyServiceResetRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserResponsiblePartyServiceResetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppUserResponsiblePartyExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppUserResponsiblePartyServiceResetRequest>): AppUserResponsiblePartyServiceResetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserResponsiblePartyServiceResetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserResponsiblePartyServiceResetRequest): AppUserResponsiblePartyServiceResetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask */ 3:
                    message.expandMask = AppUserResponsiblePartyExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserResponsiblePartyServiceResetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* c1.api.app.v1.AppUserResponsiblePartyExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppUserResponsiblePartyExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserResponsiblePartyServiceResetRequest
 */
export const AppUserResponsiblePartyServiceResetRequest = new AppUserResponsiblePartyServiceResetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserExpandMask$Type extends MessageType<AppUserExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppUserExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "identity_user_id", "app_id", "last_usage"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserExpandMask>): AppUserExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppUserExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserExpandMask): AppUserExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserExpandMask
 */
export const AppUserExpandMask = new AppUserExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserView$Type extends MessageType<AppUserView> {
    constructor() {
        super("c1.api.app.v1.AppUserView", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "identity_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_usage_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserView>): AppUserView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identityUserPath = "";
        message.appPath = "";
        message.lastUsagePath = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserView): AppUserView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUser app_user */ 1:
                    message.appUser = AppUser.internalBinaryRead(reader, reader.uint32(), options, message.appUser);
                    break;
                case /* string identity_user_path */ 2:
                    message.identityUserPath = reader.string();
                    break;
                case /* string app_path */ 3:
                    message.appPath = reader.string();
                    break;
                case /* string last_usage_path */ 4:
                    message.lastUsagePath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUser app_user = 1; */
        if (message.appUser)
            AppUser.internalBinaryWrite(message.appUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identity_user_path = 2; */
        if (message.identityUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identityUserPath);
        /* string app_path = 3; */
        if (message.appPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appPath);
        /* string last_usage_path = 4; */
        if (message.lastUsagePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lastUsagePath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserView
 */
export const AppUserView = new AppUserView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserWithAlertCountView$Type extends MessageType<AppUserWithAlertCountView> {
    constructor() {
        super("c1.api.app.v1.AppUserWithAlertCountView", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "identity_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "last_usage_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "alert_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserWithAlertCountView>): AppUserWithAlertCountView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identityUserPath = "";
        message.appPath = "";
        message.lastUsagePath = "";
        message.alertCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AppUserWithAlertCountView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserWithAlertCountView): AppUserWithAlertCountView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUser app_user */ 1:
                    message.appUser = AppUser.internalBinaryRead(reader, reader.uint32(), options, message.appUser);
                    break;
                case /* string identity_user_path */ 2:
                    message.identityUserPath = reader.string();
                    break;
                case /* string app_path */ 3:
                    message.appPath = reader.string();
                    break;
                case /* string last_usage_path */ 4:
                    message.lastUsagePath = reader.string();
                    break;
                case /* int32 alert_count */ 5:
                    message.alertCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserWithAlertCountView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUser app_user = 1; */
        if (message.appUser)
            AppUser.internalBinaryWrite(message.appUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identity_user_path = 2; */
        if (message.identityUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identityUserPath);
        /* string app_path = 3; */
        if (message.appPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appPath);
        /* string last_usage_path = 4; */
        if (message.lastUsagePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lastUsagePath);
        /* int32 alert_count = 5; */
        if (message.alertCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.alertCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserWithAlertCountView
 */
export const AppUserWithAlertCountView = new AppUserWithAlertCountView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceGetResponse$Type extends MessageType<AppUserServiceGetResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceGetResponse", [
            { no: 1, name: "app_user_view", kind: "message", T: () => AppUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceGetResponse>): AppUserServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceGetResponse): AppUserServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserView app_user_view */ 1:
                    message.appUserView = AppUserView.internalBinaryRead(reader, reader.uint32(), options, message.appUserView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserView app_user_view = 1; */
        if (message.appUserView)
            AppUserView.internalBinaryWrite(message.appUserView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceGetResponse
 */
export const AppUserServiceGetResponse = new AppUserServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceUpdateResponse$Type extends MessageType<AppUserServiceUpdateResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceUpdateResponse", [
            { no: 1, name: "app_user_view", kind: "message", T: () => AppUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceUpdateResponse>): AppUserServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceUpdateResponse): AppUserServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserView app_user_view */ 1:
                    message.appUserView = AppUserView.internalBinaryRead(reader, reader.uint32(), options, message.appUserView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserView app_user_view = 1; */
        if (message.appUserView)
            AppUserView.internalBinaryWrite(message.appUserView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceUpdateResponse
 */
export const AppUserServiceUpdateResponse = new AppUserServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserStatus$Type extends MessageType<AppUserStatus> {
    constructor() {
        super("c1.api.app.v1.AppUserStatus", [
            { no: 1, name: "status", kind: "enum", T: () => ["c1.api.app.v1.AppUserStatus.Status", AppUserStatus_Status, "STATUS_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "details", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AppUserStatus>): AppUserStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.status = 0;
        message.details = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserStatus): AppUserStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserStatus.Status status */ 1:
                    message.status = reader.int32();
                    break;
                case /* string details */ 2:
                    message.details = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserStatus.Status status = 1; */
        if (message.status !== 0)
            writer.tag(1, WireType.Varint).int32(message.status);
        /* string details = 2; */
        if (message.details !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.details);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserStatus
 */
export const AppUserStatus = new AppUserStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserRef$Type extends MessageType<AppUserRef> {
    constructor() {
        super("c1.api.app.v1.AppUserRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserRef>): AppUserRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserRef): AppUserRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserRef
 */
export const AppUserRef = new AppUserRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialRef$Type extends MessageType<AppUserCredentialRef> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserCredentialRef>): AppUserCredentialRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserCredentialRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserCredentialRef): AppUserCredentialRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserCredentialRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialRef
 */
export const AppUserCredentialRef = new AppUserCredentialRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUser$Type extends MessageType<AppUser> {
    constructor() {
        super("c1.api.app.v1.AppUser", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 12, name: "emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { minBytes: "0", maxBytes: "4096" } } } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 14, name: "usernames", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { minBytes: "0", maxBytes: "4096" } } } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 16, name: "employee_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { minBytes: "0", maxBytes: "4096" } } } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "profile", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "app_user_type", kind: "enum", T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"] },
            { no: 10, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "status", kind: "message", T: () => AppUserStatus, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 15, name: "is_external", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ], { "policy.v1.msg": { enabled: true, name: "app_user", keyFields: ["id", "app_id"] } });
    }
    create(value?: PartialMessage<AppUser>): AppUser {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        message.displayName = "";
        message.email = "";
        message.emails = [];
        message.username = "";
        message.usernames = [];
        message.employeeIds = [];
        message.appUserType = 0;
        message.identityUserId = "";
        message.isExternal = false;
        if (value !== undefined)
            reflectionMergePartial<AppUser>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUser): AppUser {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string display_name */ 6:
                    message.displayName = reader.string();
                    break;
                case /* string email */ 7:
                    message.email = reader.string();
                    break;
                case /* repeated string emails */ 12:
                    message.emails.push(reader.string());
                    break;
                case /* string username */ 13:
                    message.username = reader.string();
                    break;
                case /* repeated string usernames */ 14:
                    message.usernames.push(reader.string());
                    break;
                case /* repeated string employee_ids */ 16:
                    message.employeeIds.push(reader.string());
                    break;
                case /* google.protobuf.Struct profile */ 8:
                    message.profile = Struct.internalBinaryRead(reader, reader.uint32(), options, message.profile);
                    break;
                case /* c1.api.app.v1.AppUserType app_user_type */ 9:
                    message.appUserType = reader.int32();
                    break;
                case /* string identity_user_id */ 10:
                    message.identityUserId = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserStatus status */ 11:
                    message.status = AppUserStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* bool is_external */ 15:
                    message.isExternal = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUser, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 6; */
        if (message.displayName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.displayName);
        /* string email = 7; */
        if (message.email !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.email);
        /* google.protobuf.Struct profile = 8; */
        if (message.profile)
            Struct.internalBinaryWrite(message.profile, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUserType app_user_type = 9; */
        if (message.appUserType !== 0)
            writer.tag(9, WireType.Varint).int32(message.appUserType);
        /* string identity_user_id = 10; */
        if (message.identityUserId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.identityUserId);
        /* c1.api.app.v1.AppUserStatus status = 11; */
        if (message.status)
            AppUserStatus.internalBinaryWrite(message.status, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated string emails = 12; */
        for (let i = 0; i < message.emails.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.emails[i]);
        /* string username = 13; */
        if (message.username !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.username);
        /* repeated string usernames = 14; */
        for (let i = 0; i < message.usernames.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.usernames[i]);
        /* bool is_external = 15; */
        if (message.isExternal !== false)
            writer.tag(15, WireType.Varint).bool(message.isExternal);
        /* repeated string employee_ids = 16; */
        for (let i = 0; i < message.employeeIds.length; i++)
            writer.tag(16, WireType.LengthDelimited).string(message.employeeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUser
 */
export const AppUser = new AppUser$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceCreateRequest$Type extends MessageType<AppUserServiceCreateRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } },
            { no: 3, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceCreateRequest>): AppUserServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.displayName = "";
        message.email = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceCreateRequest): AppUserServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string email */ 3:
                    message.email = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 4:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string email = 3; */
        if (message.email !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.email);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceCreateRequest
 */
export const AppUserServiceCreateRequest = new AppUserServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceUpdateRequest$Type extends MessageType<AppUserServiceUpdateRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceUpdateRequest", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceUpdateRequest>): AppUserServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceUpdateRequest): AppUserServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUser app_user */ 1:
                    message.appUser = AppUser.internalBinaryRead(reader, reader.uint32(), options, message.appUser);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 3:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUser app_user = 1; */
        if (message.appUser)
            AppUser.internalBinaryWrite(message.appUser, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceUpdateRequest
 */
export const AppUserServiceUpdateRequest = new AppUserServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceGetRequest$Type extends MessageType<AppUserServiceGetRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceGetRequest>): AppUserServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceGetRequest): AppUserServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 3:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceGetRequest
 */
export const AppUserServiceGetRequest = new AppUserServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceDeleteRequest$Type extends MessageType<AppUserServiceDeleteRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceDeleteRequest>): AppUserServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceDeleteRequest): AppUserServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceDeleteRequest
 */
export const AppUserServiceDeleteRequest = new AppUserServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceListRequest$Type extends MessageType<AppUserServiceListRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceListRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceListRequest>): AppUserServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceListRequest): AppUserServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 4:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceListRequest
 */
export const AppUserServiceListRequest = new AppUserServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceListResponse$Type extends MessageType<AppUserServiceListResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceListResponse>): AppUserServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceListResponse): AppUserServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUserView list */ 1:
                    message.list.push(AppUserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceListResponse
 */
export const AppUserServiceListResponse = new AppUserServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUsersForUserServiceListRequest$Type extends MessageType<AppUsersForUserServiceListRequest> {
    constructor() {
        super("c1.api.app.v1.AppUsersForUserServiceListRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppUsersForUserServiceListRequest>): AppUsersForUserServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.userId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppUsersForUserServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUsersForUserServiceListRequest): AppUsersForUserServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string user_id */ 2:
                    message.userId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 5:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUsersForUserServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string user_id = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUsersForUserServiceListRequest
 */
export const AppUsersForUserServiceListRequest = new AppUsersForUserServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUsersForUserServiceListResponse$Type extends MessageType<AppUsersForUserServiceListResponse> {
    constructor() {
        super("c1.api.app.v1.AppUsersForUserServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppUsersForUserServiceListResponse>): AppUsersForUserServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppUsersForUserServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUsersForUserServiceListResponse): AppUsersForUserServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUserView list */ 1:
                    message.list.push(AppUserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUsersForUserServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUsersForUserServiceListResponse
 */
export const AppUsersForUserServiceListResponse = new AppUsersForUserServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchRequest$Type extends MessageType<AppUserServiceSearchRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 8, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 9, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserStatus.Status", AppUserStatus_Status, "STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 10, name: "app_user_status_details", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "1", maxBytes: "1024" } } } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => AppUserExpandMask },
            { no: 11, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^([a-zA-Z0-9]{27}|none)$" } } } } } },
            { no: 12, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef },
            { no: 14, name: "app_user_domains", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserDomain", AppUserDomain, "APP_USER_DOMAIN_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceSearchRequest>): AppUserServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.excludeAppUserIds = [];
        message.appUserIds = [];
        message.appId = "";
        message.appUserTypes = [];
        message.appUserStatuses = [];
        message.appUserStatusDetails = [];
        message.userIds = [];
        message.refs = [];
        message.appUserDomains = [];
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceSearchRequest): AppUserServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string exclude_app_user_ids */ 4:
                    message.excludeAppUserIds.push(reader.string());
                    break;
                case /* repeated string app_user_ids */ 5:
                    message.appUserIds.push(reader.string());
                    break;
                case /* string app_id */ 6:
                    message.appId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppUserType app_user_types */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserTypes.push(reader.int32());
                    else
                        message.appUserTypes.push(reader.int32());
                    break;
                case /* repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserStatuses.push(reader.int32());
                    else
                        message.appUserStatuses.push(reader.int32());
                    break;
                case /* repeated string app_user_status_details */ 10:
                    message.appUserStatusDetails.push(reader.string());
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 7:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string user_ids */ 11:
                    message.userIds.push(reader.string());
                    break;
                case /* repeated c1.api.app.v1.AppUserRef refs */ 12:
                    message.refs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppUserDomain app_user_domains */ 14:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserDomains.push(reader.int32());
                    else
                        message.appUserDomains.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string exclude_app_user_ids = 4; */
        for (let i = 0; i < message.excludeAppUserIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.excludeAppUserIds[i]);
        /* repeated string app_user_ids = 5; */
        for (let i = 0; i < message.appUserIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appUserIds[i]);
        /* string app_id = 6; */
        if (message.appId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.appId);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 7; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserType app_user_types = 8; */
        if (message.appUserTypes.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserTypes.length; i++)
                writer.int32(message.appUserTypes[i]);
            writer.join();
        }
        /* repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses = 9; */
        if (message.appUserStatuses.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserStatuses.length; i++)
                writer.int32(message.appUserStatuses[i]);
            writer.join();
        }
        /* repeated string app_user_status_details = 10; */
        for (let i = 0; i < message.appUserStatusDetails.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.appUserStatusDetails[i]);
        /* repeated string user_ids = 11; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.userIds[i]);
        /* repeated c1.api.app.v1.AppUserRef refs = 12; */
        for (let i = 0; i < message.refs.length; i++)
            AppUserRef.internalBinaryWrite(message.refs[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserDomain app_user_domains = 14; */
        if (message.appUserDomains.length) {
            writer.tag(14, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserDomains.length; i++)
                writer.int32(message.appUserDomains[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchRequest
 */
export const AppUserServiceSearchRequest = new AppUserServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchResponse$Type extends MessageType<AppUserServiceSearchResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceSearchResponse>): AppUserServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceSearchResponse): AppUserServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUserView list */ 1:
                    message.list.push(AppUserView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUserView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUserView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchResponse
 */
export const AppUserServiceSearchResponse = new AppUserServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchWithAlertsRequest$Type extends MessageType<AppUserServiceSearchWithAlertsRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchWithAlertsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 8, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 9, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserStatus.Status", AppUserStatus_Status, "STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 10, name: "app_user_status_details", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "1", maxBytes: "1024" } } } } } },
            { no: 7, name: "expand_mask", kind: "message", T: () => AppUserExpandMask },
            { no: 11, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^([a-zA-Z0-9]{27}|none)$" } } } } } },
            { no: 12, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef },
            { no: 13, name: "app_user_domains", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserDomain", AppUserDomain, "APP_USER_DOMAIN_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceSearchWithAlertsRequest>): AppUserServiceSearchWithAlertsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.excludeAppUserIds = [];
        message.appUserIds = [];
        message.appId = "";
        message.appUserTypes = [];
        message.appUserStatuses = [];
        message.appUserStatusDetails = [];
        message.userIds = [];
        message.refs = [];
        message.appUserDomains = [];
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceSearchWithAlertsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceSearchWithAlertsRequest): AppUserServiceSearchWithAlertsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string exclude_app_user_ids */ 4:
                    message.excludeAppUserIds.push(reader.string());
                    break;
                case /* repeated string app_user_ids */ 5:
                    message.appUserIds.push(reader.string());
                    break;
                case /* string app_id */ 6:
                    message.appId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppUserType app_user_types */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserTypes.push(reader.int32());
                    else
                        message.appUserTypes.push(reader.int32());
                    break;
                case /* repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses */ 9:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserStatuses.push(reader.int32());
                    else
                        message.appUserStatuses.push(reader.int32());
                    break;
                case /* repeated string app_user_status_details */ 10:
                    message.appUserStatusDetails.push(reader.string());
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 7:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string user_ids */ 11:
                    message.userIds.push(reader.string());
                    break;
                case /* repeated c1.api.app.v1.AppUserRef refs */ 12:
                    message.refs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppUserDomain app_user_domains */ 13:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserDomains.push(reader.int32());
                    else
                        message.appUserDomains.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceSearchWithAlertsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string exclude_app_user_ids = 4; */
        for (let i = 0; i < message.excludeAppUserIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.excludeAppUserIds[i]);
        /* repeated string app_user_ids = 5; */
        for (let i = 0; i < message.appUserIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appUserIds[i]);
        /* string app_id = 6; */
        if (message.appId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.appId);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 7; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserType app_user_types = 8; */
        if (message.appUserTypes.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserTypes.length; i++)
                writer.int32(message.appUserTypes[i]);
            writer.join();
        }
        /* repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses = 9; */
        if (message.appUserStatuses.length) {
            writer.tag(9, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserStatuses.length; i++)
                writer.int32(message.appUserStatuses[i]);
            writer.join();
        }
        /* repeated string app_user_status_details = 10; */
        for (let i = 0; i < message.appUserStatusDetails.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.appUserStatusDetails[i]);
        /* repeated string user_ids = 11; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.userIds[i]);
        /* repeated c1.api.app.v1.AppUserRef refs = 12; */
        for (let i = 0; i < message.refs.length; i++)
            AppUserRef.internalBinaryWrite(message.refs[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserDomain app_user_domains = 13; */
        if (message.appUserDomains.length) {
            writer.tag(13, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserDomains.length; i++)
                writer.int32(message.appUserDomains[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchWithAlertsRequest
 */
export const AppUserServiceSearchWithAlertsRequest = new AppUserServiceSearchWithAlertsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchWithAlertsResponse$Type extends MessageType<AppUserServiceSearchWithAlertsResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchWithAlertsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserWithAlertCountView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceSearchWithAlertsResponse>): AppUserServiceSearchWithAlertsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceSearchWithAlertsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceSearchWithAlertsResponse): AppUserServiceSearchWithAlertsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUserWithAlertCountView list */ 1:
                    message.list.push(AppUserWithAlertCountView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceSearchWithAlertsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUserWithAlertCountView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUserWithAlertCountView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchWithAlertsResponse
 */
export const AppUserServiceSearchWithAlertsResponse = new AppUserServiceSearchWithAlertsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchCountsByTypeRequest$Type extends MessageType<AppUserServiceSearchCountsByTypeRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchCountsByTypeRequest", []);
    }
    create(value?: PartialMessage<AppUserServiceSearchCountsByTypeRequest>): AppUserServiceSearchCountsByTypeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceSearchCountsByTypeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceSearchCountsByTypeRequest): AppUserServiceSearchCountsByTypeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceSearchCountsByTypeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchCountsByTypeRequest
 */
export const AppUserServiceSearchCountsByTypeRequest = new AppUserServiceSearchCountsByTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchCountRequest$Type extends MessageType<AppUserServiceSearchCountRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchCountRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "exclude_app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 5, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 6, name: "app_user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserStatus.Status", AppUserStatus_Status, "STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 7, name: "app_user_status_details", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "1", maxBytes: "1024" } } } } } },
            { no: 8, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef },
            { no: 11, name: "app_user_domains", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserDomain", AppUserDomain, "APP_USER_DOMAIN_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceSearchCountRequest>): AppUserServiceSearchCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.excludeAppUserIds = [];
        message.appUserIds = [];
        message.appId = "";
        message.appUserTypes = [];
        message.appUserStatuses = [];
        message.appUserStatusDetails = [];
        message.userIds = [];
        message.refs = [];
        message.appUserDomains = [];
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceSearchCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceSearchCountRequest): AppUserServiceSearchCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* repeated string exclude_app_user_ids */ 2:
                    message.excludeAppUserIds.push(reader.string());
                    break;
                case /* repeated string app_user_ids */ 3:
                    message.appUserIds.push(reader.string());
                    break;
                case /* string app_id */ 4:
                    message.appId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppUserType app_user_types */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserTypes.push(reader.int32());
                    else
                        message.appUserTypes.push(reader.int32());
                    break;
                case /* repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses */ 6:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserStatuses.push(reader.int32());
                    else
                        message.appUserStatuses.push(reader.int32());
                    break;
                case /* repeated string app_user_status_details */ 7:
                    message.appUserStatusDetails.push(reader.string());
                    break;
                case /* repeated string user_ids */ 8:
                    message.userIds.push(reader.string());
                    break;
                case /* repeated c1.api.app.v1.AppUserRef refs */ 9:
                    message.refs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppUserDomain app_user_domains */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.appUserDomains.push(reader.int32());
                    else
                        message.appUserDomains.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceSearchCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* repeated string exclude_app_user_ids = 2; */
        for (let i = 0; i < message.excludeAppUserIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.excludeAppUserIds[i]);
        /* repeated string app_user_ids = 3; */
        for (let i = 0; i < message.appUserIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.appUserIds[i]);
        /* string app_id = 4; */
        if (message.appId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appId);
        /* repeated c1.api.app.v1.AppUserType app_user_types = 5; */
        if (message.appUserTypes.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserTypes.length; i++)
                writer.int32(message.appUserTypes[i]);
            writer.join();
        }
        /* repeated c1.api.app.v1.AppUserStatus.Status app_user_statuses = 6; */
        if (message.appUserStatuses.length) {
            writer.tag(6, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserStatuses.length; i++)
                writer.int32(message.appUserStatuses[i]);
            writer.join();
        }
        /* repeated string app_user_status_details = 7; */
        for (let i = 0; i < message.appUserStatusDetails.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.appUserStatusDetails[i]);
        /* repeated string user_ids = 8; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.userIds[i]);
        /* repeated c1.api.app.v1.AppUserRef refs = 9; */
        for (let i = 0; i < message.refs.length; i++)
            AppUserRef.internalBinaryWrite(message.refs[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserDomain app_user_domains = 11; */
        if (message.appUserDomains.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.appUserDomains.length; i++)
                writer.int32(message.appUserDomains[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchCountRequest
 */
export const AppUserServiceSearchCountRequest = new AppUserServiceSearchCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchCountResponse$Type extends MessageType<AppUserServiceSearchCountResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceSearchCountResponse>): AppUserServiceSearchCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceSearchCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceSearchCountResponse): AppUserServiceSearchCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceSearchCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchCountResponse
 */
export const AppUserServiceSearchCountResponse = new AppUserServiceSearchCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceSearchCountsByTypeResponse$Type extends MessageType<AppUserServiceSearchCountsByTypeResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceSearchCountsByTypeResponse", [
            { no: 1, name: "user", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "service_account", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "system_account", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceSearchCountsByTypeResponse>): AppUserServiceSearchCountsByTypeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.user = 0;
        message.serviceAccount = 0;
        message.systemAccount = 0;
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceSearchCountsByTypeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceSearchCountsByTypeResponse): AppUserServiceSearchCountsByTypeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 user */ 1:
                    message.user = reader.int64().toNumber();
                    break;
                case /* int64 service_account */ 2:
                    message.serviceAccount = reader.int64().toNumber();
                    break;
                case /* int64 system_account */ 3:
                    message.systemAccount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceSearchCountsByTypeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 user = 1; */
        if (message.user !== 0)
            writer.tag(1, WireType.Varint).int64(message.user);
        /* int64 service_account = 2; */
        if (message.serviceAccount !== 0)
            writer.tag(2, WireType.Varint).int64(message.serviceAccount);
        /* int64 system_account = 3; */
        if (message.systemAccount !== 0)
            writer.tag(3, WireType.Varint).int64(message.systemAccount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceSearchCountsByTypeResponse
 */
export const AppUserServiceSearchCountsByTypeResponse = new AppUserServiceSearchCountsByTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserSearchTermsRequest$Type extends MessageType<GetUserSearchTermsRequest> {
    constructor() {
        super("c1.api.app.v1.GetUserSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => AppUserServiceSearchRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.app.v1.AppUserSearchTerm", AppUserSearchTerm], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GetUserSearchTermsRequest>): GetUserSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.term = 0;
        message.query = "";
        message.includeCount = false;
        if (value !== undefined)
            reflectionMergePartial<GetUserSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUserSearchTermsRequest): GetUserSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserServiceSearchRequest search */ 1:
                    message.search = AppUserServiceSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.search);
                    break;
                case /* c1.api.app.v1.AppUserSearchTerm term */ 2:
                    message.term = reader.int32();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_count */ 4:
                    message.includeCount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUserSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserServiceSearchRequest search = 1; */
        if (message.search)
            AppUserServiceSearchRequest.internalBinaryWrite(message.search, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUserSearchTerm term = 2; */
        if (message.term !== 0)
            writer.tag(2, WireType.Varint).int32(message.term);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_count = 4; */
        if (message.includeCount !== false)
            writer.tag(4, WireType.Varint).bool(message.includeCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetUserSearchTermsRequest
 */
export const GetUserSearchTermsRequest = new GetUserSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserSearchTermsResponse$Type extends MessageType<GetUserSearchTermsResponse> {
    constructor() {
        super("c1.api.app.v1.GetUserSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
    create(value?: PartialMessage<GetUserSearchTermsResponse>): GetUserSearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetUserSearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetUserSearchTermsResponse): GetUserSearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.search.v1.Facets facets */ 1:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetUserSearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.search.v1.Facets facets = 1; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetUserSearchTermsResponse
 */
export const GetUserSearchTermsResponse = new GetUserSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithUserCountRollup$Type extends MessageType<AppWithUserCountRollup> {
    constructor() {
        super("c1.api.app.v1.AppWithUserCountRollup", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "user_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppWithUserCountRollup>): AppWithUserCountRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AppWithUserCountRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppWithUserCountRollup): AppWithUserCountRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* int64 user_count */ 2:
                    message.userCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppWithUserCountRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 user_count = 2; */
        if (message.userCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.userCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppWithUserCountRollup
 */
export const AppWithUserCountRollup = new AppWithUserCountRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithUserCountRollupRequest$Type extends MessageType<AppWithUserCountRollupRequest> {
    constructor() {
        super("c1.api.app.v1.AppWithUserCountRollupRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AppWithUserCountRollupRequest>): AppWithUserCountRollupRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppWithUserCountRollupRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppWithUserCountRollupRequest): AppWithUserCountRollupRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppWithUserCountRollupRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppWithUserCountRollupRequest
 */
export const AppWithUserCountRollupRequest = new AppWithUserCountRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithUserCountRollupResponse$Type extends MessageType<AppWithUserCountRollupResponse> {
    constructor() {
        super("c1.api.app.v1.AppWithUserCountRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppWithUserCountRollup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppWithUserCountRollupResponse>): AppWithUserCountRollupResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppWithUserCountRollupResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppWithUserCountRollupResponse): AppWithUserCountRollupResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppWithUserCountRollup list */ 1:
                    message.list.push(AppWithUserCountRollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppWithUserCountRollupResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppWithUserCountRollup list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppWithUserCountRollup.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppWithUserCountRollupResponse
 */
export const AppWithUserCountRollupResponse = new AppWithUserCountRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersWithoutResponsiblePartyRequest$Type extends MessageType<CountAppUsersWithoutResponsiblePartyRequest> {
    constructor() {
        super("c1.api.app.v1.CountAppUsersWithoutResponsiblePartyRequest", []);
    }
    create(value?: PartialMessage<CountAppUsersWithoutResponsiblePartyRequest>): CountAppUsersWithoutResponsiblePartyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CountAppUsersWithoutResponsiblePartyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountAppUsersWithoutResponsiblePartyRequest): CountAppUsersWithoutResponsiblePartyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountAppUsersWithoutResponsiblePartyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountAppUsersWithoutResponsiblePartyRequest
 */
export const CountAppUsersWithoutResponsiblePartyRequest = new CountAppUsersWithoutResponsiblePartyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersWithoutResponsiblePartyResponse$Type extends MessageType<CountAppUsersWithoutResponsiblePartyResponse> {
    constructor() {
        super("c1.api.app.v1.CountAppUsersWithoutResponsiblePartyResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountAppUsersWithoutResponsiblePartyResponse>): CountAppUsersWithoutResponsiblePartyResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountAppUsersWithoutResponsiblePartyResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountAppUsersWithoutResponsiblePartyResponse): CountAppUsersWithoutResponsiblePartyResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountAppUsersWithoutResponsiblePartyResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountAppUsersWithoutResponsiblePartyResponse
 */
export const CountAppUsersWithoutResponsiblePartyResponse = new CountAppUsersWithoutResponsiblePartyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUsersWithoutResponsiblePartyRequest$Type extends MessageType<AppUsersWithoutResponsiblePartyRequest> {
    constructor() {
        super("c1.api.app.v1.AppUsersWithoutResponsiblePartyRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$|" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppUsersWithoutResponsiblePartyRequest>): AppUsersWithoutResponsiblePartyRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppUsersWithoutResponsiblePartyRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUsersWithoutResponsiblePartyRequest): AppUsersWithoutResponsiblePartyRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserExpandMask expand_mask */ 4:
                    message.expandMask = AppUserExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUsersWithoutResponsiblePartyRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppUserExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppUserExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUsersWithoutResponsiblePartyRequest
 */
export const AppUsersWithoutResponsiblePartyRequest = new AppUsersWithoutResponsiblePartyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TotalCountOrphanedAccountsRequest$Type extends MessageType<TotalCountOrphanedAccountsRequest> {
    constructor() {
        super("c1.api.app.v1.TotalCountOrphanedAccountsRequest", []);
    }
    create(value?: PartialMessage<TotalCountOrphanedAccountsRequest>): TotalCountOrphanedAccountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TotalCountOrphanedAccountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TotalCountOrphanedAccountsRequest): TotalCountOrphanedAccountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TotalCountOrphanedAccountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.TotalCountOrphanedAccountsRequest
 */
export const TotalCountOrphanedAccountsRequest = new TotalCountOrphanedAccountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TotalCountOrphanedAccountsResponse$Type extends MessageType<TotalCountOrphanedAccountsResponse> {
    constructor() {
        super("c1.api.app.v1.TotalCountOrphanedAccountsResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<TotalCountOrphanedAccountsResponse>): TotalCountOrphanedAccountsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<TotalCountOrphanedAccountsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TotalCountOrphanedAccountsResponse): TotalCountOrphanedAccountsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TotalCountOrphanedAccountsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.TotalCountOrphanedAccountsResponse
 */
export const TotalCountOrphanedAccountsResponse = new TotalCountOrphanedAccountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptedData$Type extends MessageType<EncryptedData> {
    constructor() {
        super("c1.api.app.v1.EncryptedData", [
            { no: 1, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "key_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "schema", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "encrypted_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<EncryptedData>): EncryptedData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.provider = "";
        message.keyId = "";
        message.name = "";
        message.description = "";
        message.schema = "";
        message.encryptedBytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<EncryptedData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EncryptedData): EncryptedData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string provider */ 1:
                    message.provider = reader.string();
                    break;
                case /* string key_id */ 2:
                    message.keyId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string schema */ 5:
                    message.schema = reader.string();
                    break;
                case /* bytes encrypted_bytes */ 6:
                    message.encryptedBytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EncryptedData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string provider = 1; */
        if (message.provider !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.provider);
        /* string key_id = 2; */
        if (message.keyId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.keyId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string schema = 5; */
        if (message.schema !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.schema);
        /* bytes encrypted_bytes = 6; */
        if (message.encryptedBytes.length)
            writer.tag(6, WireType.LengthDelimited).bytes(message.encryptedBytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.EncryptedData
 */
export const EncryptedData = new EncryptedData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredential$Type extends MessageType<AppUserCredential> {
    constructor() {
        super("c1.api.app.v1.AppUserCredential", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "expires_at", kind: "message", T: () => Timestamp },
            { no: 100, name: "encrypted_data", kind: "message", oneof: "credential", T: () => EncryptedData }
        ]);
    }
    create(value?: PartialMessage<AppUserCredential>): AppUserCredential {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        message.id = "";
        message.credential = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AppUserCredential>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserCredential): AppUserCredential {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 6:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp expires_at */ 7:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                case /* c1.api.app.v1.EncryptedData encrypted_data */ 100:
                    message.credential = {
                        oneofKind: "encryptedData",
                        encryptedData: EncryptedData.internalBinaryRead(reader, reader.uint32(), options, (message.credential as any).encryptedData)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserCredential, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 6; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expires_at = 7; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.EncryptedData encrypted_data = 100; */
        if (message.credential.oneofKind === "encryptedData")
            EncryptedData.internalBinaryWrite(message.credential.encryptedData, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredential
 */
export const AppUserCredential = new AppUserCredential$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialView$Type extends MessageType<AppUserCredentialView> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialView", [
            { no: 1, name: "app_user_credential", kind: "message", T: () => AppUserCredential },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserCredentialView>): AppUserCredentialView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.appUserPath = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserCredentialView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserCredentialView): AppUserCredentialView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserCredential app_user_credential */ 1:
                    message.appUserCredential = AppUserCredential.internalBinaryRead(reader, reader.uint32(), options, message.appUserCredential);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string app_user_path */ 3:
                    message.appUserPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserCredentialView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserCredential app_user_credential = 1; */
        if (message.appUserCredential)
            AppUserCredential.internalBinaryWrite(message.appUserCredential, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string app_user_path = 3; */
        if (message.appUserPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialView
 */
export const AppUserCredentialView = new AppUserCredentialView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialViewWithVaultID$Type extends MessageType<AppUserCredentialViewWithVaultID> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialViewWithVaultID", [
            { no: 1, name: "item", kind: "message", T: () => AppUserCredentialView },
            { no: 2, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AppUserCredentialViewWithVaultID>): AppUserCredentialViewWithVaultID {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vaultId = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AppUserCredentialViewWithVaultID>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserCredentialViewWithVaultID): AppUserCredentialViewWithVaultID {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppUserCredentialView item */ 1:
                    message.item = AppUserCredentialView.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                case /* string vault_id */ 2:
                    message.vaultId = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserCredentialViewWithVaultID, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppUserCredentialView item = 1; */
        if (message.item)
            AppUserCredentialView.internalBinaryWrite(message.item, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string vault_id = 2; */
        if (message.vaultId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vaultId);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialViewWithVaultID
 */
export const AppUserCredentialViewWithVaultID = new AppUserCredentialViewWithVaultID$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialExpandMask$Type extends MessageType<AppUserCredentialExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "app_user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserCredentialExpandMask>): AppUserCredentialExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppUserCredentialExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserCredentialExpandMask): AppUserCredentialExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserCredentialExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialExpandMask
 */
export const AppUserCredentialExpandMask = new AppUserCredentialExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceListCredentialsRequest$Type extends MessageType<AppUserServiceListCredentialsRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceListCredentialsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceListCredentialsRequest>): AppUserServiceListCredentialsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceListCredentialsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceListCredentialsRequest): AppUserServiceListCredentialsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceListCredentialsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceListCredentialsRequest
 */
export const AppUserServiceListCredentialsRequest = new AppUserServiceListCredentialsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserServiceListCredentialsResponse$Type extends MessageType<AppUserServiceListCredentialsResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserServiceListCredentialsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserCredential },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserServiceListCredentialsResponse>): AppUserServiceListCredentialsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserServiceListCredentialsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserServiceListCredentialsResponse): AppUserServiceListCredentialsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUserCredential list */ 1:
                    message.list.push(AppUserCredential.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserServiceListCredentialsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUserCredential list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUserCredential.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserServiceListCredentialsResponse
 */
export const AppUserServiceListCredentialsResponse = new AppUserServiceListCredentialsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserSearchFilter$Type extends MessageType<AppUserSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppUserSearchFilter", [
            { no: 1, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef }
        ]);
    }
    create(value?: PartialMessage<AppUserSearchFilter>): AppUserSearchFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AppUserSearchFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserSearchFilter): AppUserSearchFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUserRef refs */ 1:
                    message.refs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserSearchFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUserRef refs = 1; */
        for (let i = 0; i < message.refs.length; i++)
            AppUserRef.internalBinaryWrite(message.refs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserSearchFilter
 */
export const AppUserSearchFilter = new AppUserSearchFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialServiceSearchTermsRequest$Type extends MessageType<AppUserCredentialServiceSearchTermsRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => SearchAppUserCredentialsByVaultIDRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest.TermType", AppUserCredentialServiceSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppUserCredentialServiceSearchTermsRequest>): AppUserCredentialServiceSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.term = 0;
        message.query = "";
        message.includeCount = false;
        if (value !== undefined)
            reflectionMergePartial<AppUserCredentialServiceSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserCredentialServiceSearchTermsRequest): AppUserCredentialServiceSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.SearchAppUserCredentialsByVaultIDRequest search */ 1:
                    message.search = SearchAppUserCredentialsByVaultIDRequest.internalBinaryRead(reader, reader.uint32(), options, message.search);
                    break;
                case /* c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest.TermType term */ 2:
                    message.term = reader.int32();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_count */ 4:
                    message.includeCount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserCredentialServiceSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.SearchAppUserCredentialsByVaultIDRequest search = 1; */
        if (message.search)
            SearchAppUserCredentialsByVaultIDRequest.internalBinaryWrite(message.search, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest.TermType term = 2; */
        if (message.term !== 0)
            writer.tag(2, WireType.Varint).int32(message.term);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_count = 4; */
        if (message.includeCount !== false)
            writer.tag(4, WireType.Varint).bool(message.includeCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialServiceSearchTermsRequest
 */
export const AppUserCredentialServiceSearchTermsRequest = new AppUserCredentialServiceSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialServiceSearchTermsResponse$Type extends MessageType<AppUserCredentialServiceSearchTermsResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialServiceSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
    create(value?: PartialMessage<AppUserCredentialServiceSearchTermsResponse>): AppUserCredentialServiceSearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppUserCredentialServiceSearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserCredentialServiceSearchTermsResponse): AppUserCredentialServiceSearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.search.v1.Facets facets */ 1:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserCredentialServiceSearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.search.v1.Facets facets = 1; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialServiceSearchTermsResponse
 */
export const AppUserCredentialServiceSearchTermsResponse = new AppUserCredentialServiceSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppUserCredentialsWithVaultRequest$Type extends MessageType<ListAppUserCredentialsWithVaultRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppUserCredentialsWithVaultRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppUserCredentialExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListAppUserCredentialsWithVaultRequest>): ListAppUserCredentialsWithVaultRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppUserCredentialsWithVaultRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppUserCredentialsWithVaultRequest): ListAppUserCredentialsWithVaultRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserCredentialExpandMask expand_mask */ 5:
                    message.expandMask = AppUserCredentialExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppUserCredentialsWithVaultRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppUserCredentialExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppUserCredentialExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppUserCredentialsWithVaultRequest
 */
export const ListAppUserCredentialsWithVaultRequest = new ListAppUserCredentialsWithVaultRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppUserCredentialsWithVaultResponse$Type extends MessageType<ListAppUserCredentialsWithVaultResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppUserCredentialsWithVaultResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserCredentialViewWithVaultID },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ListAppUserCredentialsWithVaultResponse>): ListAppUserCredentialsWithVaultResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppUserCredentialsWithVaultResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppUserCredentialsWithVaultResponse): ListAppUserCredentialsWithVaultResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUserCredentialViewWithVaultID list */ 1:
                    message.list.push(AppUserCredentialViewWithVaultID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppUserCredentialsWithVaultResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUserCredentialViewWithVaultID list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUserCredentialViewWithVaultID.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppUserCredentialsWithVaultResponse
 */
export const ListAppUserCredentialsWithVaultResponse = new ListAppUserCredentialsWithVaultResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserCredentialsByVaultIDRequest$Type extends MessageType<SearchAppUserCredentialsByVaultIDRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppUserCredentialsByVaultIDRequest", [
            { no: 1, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppUserCredentialExpandMask },
            { no: 5, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppUserCredentialsByVaultIDRequest>): SearchAppUserCredentialsByVaultIDRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vaultId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppUserCredentialsByVaultIDRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppUserCredentialsByVaultIDRequest): SearchAppUserCredentialsByVaultIDRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string vault_id */ 1:
                    message.vaultId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppUserCredentialExpandMask expand_mask */ 4:
                    message.expandMask = AppUserCredentialExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* string query */ 5:
                    message.query = reader.string();
                    break;
                case /* repeated string app_ids */ 6:
                    message.appIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppUserCredentialsByVaultIDRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string vault_id = 1; */
        if (message.vaultId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.vaultId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppUserCredentialExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppUserCredentialExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string query = 5; */
        if (message.query !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.query);
        /* repeated string app_ids = 6; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.appIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUserCredentialsByVaultIDRequest
 */
export const SearchAppUserCredentialsByVaultIDRequest = new SearchAppUserCredentialsByVaultIDRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserCredentialsByVaultIDResponse$Type extends MessageType<SearchAppUserCredentialsByVaultIDResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppUserCredentialsByVaultIDResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserCredentialView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchAppUserCredentialsByVaultIDResponse>): SearchAppUserCredentialsByVaultIDResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppUserCredentialsByVaultIDResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppUserCredentialsByVaultIDResponse): SearchAppUserCredentialsByVaultIDResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppUserCredentialView list */ 1:
                    message.list.push(AppUserCredentialView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppUserCredentialsByVaultIDResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppUserCredentialView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppUserCredentialView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUserCredentialsByVaultIDResponse
 */
export const SearchAppUserCredentialsByVaultIDResponse = new SearchAppUserCredentialsByVaultIDResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserHasAppUserCredentialsRequest$Type extends MessageType<SearchAppUserHasAppUserCredentialsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppUserHasAppUserCredentialsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppUserHasAppUserCredentialsRequest>): SearchAppUserHasAppUserCredentialsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppUserHasAppUserCredentialsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppUserHasAppUserCredentialsRequest): SearchAppUserHasAppUserCredentialsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppUserHasAppUserCredentialsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUserHasAppUserCredentialsRequest
 */
export const SearchAppUserHasAppUserCredentialsRequest = new SearchAppUserHasAppUserCredentialsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUserHasAppUserCredentialsResponse$Type extends MessageType<SearchAppUserHasAppUserCredentialsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppUserHasAppUserCredentialsResponse", [
            { no: 1, name: "has_app_user_credentials", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppUserHasAppUserCredentialsResponse>): SearchAppUserHasAppUserCredentialsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hasAppUserCredentials = false;
        if (value !== undefined)
            reflectionMergePartial<SearchAppUserHasAppUserCredentialsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppUserHasAppUserCredentialsResponse): SearchAppUserHasAppUserCredentialsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool has_app_user_credentials */ 1:
                    message.hasAppUserCredentials = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppUserHasAppUserCredentialsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool has_app_user_credentials = 1; */
        if (message.hasAppUserCredentials !== false)
            writer.tag(1, WireType.Varint).bool(message.hasAppUserCredentials);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUserHasAppUserCredentialsResponse
 */
export const SearchAppUserHasAppUserCredentialsResponse = new SearchAppUserHasAppUserCredentialsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialServiceDeleteRequest$Type extends MessageType<AppUserCredentialServiceDeleteRequest> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "credential_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppUserCredentialServiceDeleteRequest>): AppUserCredentialServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appUserId = "";
        message.credentialId = "";
        if (value !== undefined)
            reflectionMergePartial<AppUserCredentialServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserCredentialServiceDeleteRequest): AppUserCredentialServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 2:
                    message.appUserId = reader.string();
                    break;
                case /* string credential_id */ 3:
                    message.credentialId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserCredentialServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 2; */
        if (message.appUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserId);
        /* string credential_id = 3; */
        if (message.credentialId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.credentialId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialServiceDeleteRequest
 */
export const AppUserCredentialServiceDeleteRequest = new AppUserCredentialServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppUserCredentialServiceDeleteResponse$Type extends MessageType<AppUserCredentialServiceDeleteResponse> {
    constructor() {
        super("c1.api.app.v1.AppUserCredentialServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<AppUserCredentialServiceDeleteResponse>): AppUserCredentialServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppUserCredentialServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppUserCredentialServiceDeleteResponse): AppUserCredentialServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppUserCredentialServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppUserCredentialServiceDeleteResponse
 */
export const AppUserCredentialServiceDeleteResponse = new AppUserCredentialServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppAccountRollup$Type extends MessageType<AppAccountRollup> {
    constructor() {
        super("c1.api.app.v1.AppAccountRollup", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppAccountRollup>): AppAccountRollup {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<AppAccountRollup>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppAccountRollup): AppAccountRollup {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* int64 count */ 2:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppAccountRollup, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* int64 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAccountRollup
 */
export const AppAccountRollup = new AppAccountRollup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersByAppsRequest$Type extends MessageType<CountAppUsersByAppsRequest> {
    constructor() {
        super("c1.api.app.v1.CountAppUsersByAppsRequest", [
            { no: 1, name: "app_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100", items: { message: { skip: false } } } } } }
        ]);
    }
    create(value?: PartialMessage<CountAppUsersByAppsRequest>): CountAppUsersByAppsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appRefs = [];
        if (value !== undefined)
            reflectionMergePartial<CountAppUsersByAppsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountAppUsersByAppsRequest): CountAppUsersByAppsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppRef app_refs */ 1:
                    message.appRefs.push(AppRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountAppUsersByAppsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppRef app_refs = 1; */
        for (let i = 0; i < message.appRefs.length; i++)
            AppRef.internalBinaryWrite(message.appRefs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountAppUsersByAppsRequest
 */
export const CountAppUsersByAppsRequest = new CountAppUsersByAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountAppUsersByAppsResponse$Type extends MessageType<CountAppUsersByAppsResponse> {
    constructor() {
        super("c1.api.app.v1.CountAppUsersByAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppAccountRollup }
        ]);
    }
    create(value?: PartialMessage<CountAppUsersByAppsResponse>): CountAppUsersByAppsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<CountAppUsersByAppsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountAppUsersByAppsResponse): CountAppUsersByAppsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppAccountRollup list */ 1:
                    message.list.push(AppAccountRollup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountAppUsersByAppsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppAccountRollup list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppAccountRollup.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountAppUsersByAppsResponse
 */
export const CountAppUsersByAppsResponse = new CountAppUsersByAppsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppUserService
 */
export const AppUserService = new ServiceType("c1.api.app.v1.AppUserService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: AppUserServiceGetRequest, O: AppUserServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/app_users", query: { page_size: "page_size", page_token: "page_token" }, group: "AppUsers" }] } }, I: AppUserServiceListRequest, O: AppUserServiceListResponse },
    { name: "ListAppUsersForUser", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/users/{user_id}/app_users", query: { page_size: "page_size", page_token: "page_token" }, group: "AppUsers" }] } }, I: AppUsersForUserServiceListRequest, O: AppUsersForUserServiceListResponse },
    { name: "ListAppUserCredentials", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/app_users/{app_user_id}/credentials", query: { page_size: "page_size", page_token: "page_token" }, group: "AppUsers" }] } }, I: AppUserServiceListCredentialsRequest, O: AppUserServiceListCredentialsResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: AppUserServiceCreateRequest, O: AppUserServiceGetResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_user.app_id}/app_users/{app_user.id}", group: "AppUsers" }] } }, I: AppUserServiceUpdateRequest, O: AppUserServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: AppUserServiceDeleteRequest, O: Empty },
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/app_users", group: "AppUsers" }] } }, I: AppUserServiceSearchRequest, O: AppUserServiceSearchResponse },
    { name: "SearchWithAlerts", options: { "authz.method": { role: "VIEWER" } }, I: AppUserServiceSearchWithAlertsRequest, O: AppUserServiceSearchWithAlertsResponse },
    { name: "SearchCount", options: { "authz.method": { role: "VIEWER" } }, I: AppUserServiceSearchCountRequest, O: AppUserServiceSearchCountResponse },
    { name: "SearchCountsByType", options: { "authz.method": { role: "VIEWER" } }, I: AppUserServiceSearchCountsByTypeRequest, O: AppUserServiceSearchCountsByTypeResponse },
    { name: "GetUserSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: GetUserSearchTermsRequest, O: GetUserSearchTermsResponse },
    { name: "CountOrphanedAccounts", options: { "authz.method": { role: "VIEWER" } }, I: AppWithUserCountRollupRequest, O: AppWithUserCountRollupResponse },
    { name: "CountAppUsersWithoutResponsibleParty", options: { "authz.method": { role: "VIEWER" } }, I: CountAppUsersWithoutResponsiblePartyRequest, O: CountAppUsersWithoutResponsiblePartyResponse },
    { name: "AppUsersWithoutResponsibleParty", options: { "authz.method": { role: "VIEWER" } }, I: AppUsersWithoutResponsiblePartyRequest, O: AppUserServiceListResponse },
    { name: "HighRiskUsersAndGrants", options: { "authz.method": { role: "VIEWER" } }, I: HighRiskUsersAndGrantsRequest, O: HighRiskUsersAndGrantsResponse },
    { name: "CountHighRiskUsersAndGrants", options: { "authz.method": { role: "VIEWER" } }, I: CountHighRiskUsersAndGrantsRequest, O: CountHighRiskUsersAndGrantsResponse },
    { name: "TotalCountOrphanedAccounts", options: { "authz.method": { role: "VIEWER" } }, I: TotalCountOrphanedAccountsRequest, O: TotalCountOrphanedAccountsResponse },
    { name: "SearchOrphanedAccounts", options: { "authz.method": { role: "VIEWER" } }, I: SearchOrphanedAccountsRequest, O: SearchOrphanedAccountsResponse },
    { name: "CountAppUsersByApps", options: { "authz.method": { role: "VIEWER" } }, I: CountAppUsersByAppsRequest, O: CountAppUsersByAppsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppUserCredentialService
 */
export const AppUserCredentialService = new ServiceType("c1.api.app.v1.AppUserCredentialService", [
    { name: "ListAppUserCredentialsWithVault", options: { "authz.method": { role: "VIEWER" } }, I: ListAppUserCredentialsWithVaultRequest, O: ListAppUserCredentialsWithVaultResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: AppUserCredentialServiceSearchTermsRequest, O: AppUserCredentialServiceSearchTermsResponse },
    { name: "SearchAppUserCredentialsByVaultID", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppUserCredentialsByVaultIDRequest, O: SearchAppUserCredentialsByVaultIDResponse },
    { name: "SearchAppUserHasAppUserCredentials", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppUserHasAppUserCredentialsRequest, O: SearchAppUserHasAppUserCredentialsResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: AppUserCredentialServiceDeleteRequest, O: AppUserCredentialServiceDeleteResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppUserResponsiblePartyService
 */
export const AppUserResponsiblePartyService = new ServiceType("c1.api.app.v1.AppUserResponsiblePartyService", [
    { name: "SetIdentity", options: { "authz.method": { role: "EDITOR" } }, I: AppUserResponsiblePartyServiceSetRequest, O: AppUserServiceGetResponse },
    { name: "ResetIdentity", options: { "authz.method": { role: "EDITOR" } }, I: AppUserResponsiblePartyServiceResetRequest, O: AppUserServiceGetResponse }
]);
